<template>
  <div
    ref="card"
    :class="$style.card"
    @click="navigateToCar"
  >
    <div :class="$style.header">
      <div :class="$style.brandLogo">
        <img
          :src="brandLogo"
          :alt="brandName"
        >
      </div>
      <div
        v-if="!['CHMSL','AuxHL','AuxRL'].includes(type)"
        :class="$style.supplierLogo"
      >
        <img
          :src="supplierLogo"
          :alt="supplierName"
        >
      </div>

      <div :class="[$style.infoRow, $style.isTop]">
        <div :class="$style.infoRowSection">
          <span :class="$style.spec">
            <span>
              {{ (volume || 0).toLocaleString() }} units
            </span>
          </span>
          <BaseLabel
            v-if="!['CHMSL','AuxHL','AuxRL'].includes(type)"
            :class="$style.label"
            color="aqua"
          >
            {{ supplierRegion }}
            <img
              :src="`/images/icons/flags/${supplierCountry.toLowerCase()}.png`"
              :alt="supplierCountry"
              :class="$style.flag"
            >
          </BaseLabel>
        </div>
      </div>
    </div>
    <div :class="$style.images">
      <div
        :class="$style.image"
        :style="{ backgroundImage: `url('${frontImage || defaultDeviceImage}')` }"
      />
      <div
        :class="$style.image"
        :style="{ backgroundImage: `url('${carImage || defaultCarImage}')` }"
      />
      <div
        :class="$style.typeLabelWrapper"
      >
        <BaseLabel
          v-if="showType"
          :color="getDeviceTypeLabelColor(type)"
        >
          {{ type }}
        </BaseLabel>
      </div>
    </div>
    <div :class="[$style.infoRow, $style.isBottom]">
      <div :class="$style.infoRowSection">
        <span :class="$style.spec">
          <DateStartSvg />
          <span>
            {{ format(new Date(minSop), 'MMM y') }} – {{ format(new Date(maxEop), 'MMM y') }}
          </span>
        </span>
      </div>
      <div :class="$style.infoRowSection">
        <span :class="$style.spec">
          <BoxSvg />
          <span>
            {{ (carsNumber || 0).toLocaleString() }} cars
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns';
import BaseLabel from '@/components/base/Label';
import BoxSvg from '@/assets/images/icons/table-box.svg?inline';
import DateStartSvg from '@/assets/images/icons/table-date-start.svg?inline';
import getDeviceTypeLabelColor from '@/utils/getDeviceTypeLabelColor';

export default {
  components: {
    BaseLabel,
    BoxSvg,
    DateStartSvg,
  },
  props: {
    deviceId: {
      type: Number,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    brandName: {
      type: String,
      default: null,
    },
    brandLogo: {
      type: String,
      default: null,
    },
    supplierName: {
      type: String,
      default: null,
    },
    supplierLogo: {
      type: String,
      default: null,
    },
    volume: {
      type: Number,
      default: null,
    },
    supplierRegion: {
      type: String,
      default: null,
    },
    supplierCountry: {
      type: String,
      default: null,
    },
    frontImage: {
      type: String,
      default: null,
    },
    carImage: {
      type: String,
      default: null,
    },
    minSop: {
      type: String,
      default: null,
    },
    maxEop: {
      type: String,
      default: null,
    },
    carsNumber: {
      type: Number,
      default: null,
    },
    showType: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    defaultDeviceImage() {
      switch (this.type) {
        case 'HL':
          return '/images/default-hl-front.jpg';
        case 'RL':
          return '/images/default-rl-front.jpg';
        default:
          return null;
      }
    },
    defaultCarImage() {
      switch (this.type) {
        case 'HL':
          return '/images/default-car-front.jpg';
        case 'RL':
          return '/images/default-car-back.jpg';
        default:
          return null;
      }
    },
  },
  methods: {
    format,
    getDeviceTypeLabelColor,
    navigateToCar() {
      const selection = window.getSelection();
      const isTextSelected = selection.toString() !== '';

      if (
        isTextSelected
        && (
          this.$refs.card.contains(selection.anchorNode)
          || this.$refs.card.contains(selection.focusNode)
        )
      ) {
        return;
      }

      this.$router.push({ name: 'Products/Device', params: { deviceId: this.deviceId } });
    },
  },
};
</script>

<style lang="scss" module>
.card {
  padding: 25px 20px;
  cursor: pointer;
}

.header {
  display: flex;
  align-items: center;
}

.brandLogo,
.supplierLogo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;

  img {
    max-width: 100%;
    max-height: 100%;
  }
}

.brandLogo {
  margin-right: 3px;
}

.flag {
  margin-bottom: -1px;
  margin-left: 3px;
}

.infoRow {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &.isTop {
    margin-left: auto;
  }

  &.isBottom {
    margin-top: 10px;
  }
}

.infoRowSection {
  display: flex;
  align-items: center;

  .label {

    &:not(:first-child) {
      margin-left: 5px;
    }
  }
}

.spec {
  display: inline-flex;
  align-items: center;
  font-size: 13px;

  &:not(:first-child) {
    margin-left: 15px;
  }

  svg {
    margin-top: -3px;
    margin-right: 5px;
  }
}

.images {
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.image {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(50% - 4px);
  padding-top: 40.625%;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border-radius: 5px;

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: inline-block;
    content: '';
    background: linear-gradient(
      180deg, rgba(230, 230, 230, 0.5) 0%, rgba(146, 147, 148, 0.25) 43%, rgba(15, 18, 20, 0.25) 100%
    );
    opacity: 0.5;
  }

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    max-width: 100%;
    max-height: 100%;
    transform: translate(-50%, -50%);
  }
}

.typeLabelWrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  border-radius: 5px;
  box-shadow: 0 0 0 2px #fff;
}
</style>
